module.exports = __webpack_public_path__ + "media/images/athletes/2945-5b8ac69f65f9e6c5b42a84c7cf1c0898.png";